/**
 * Export component file to be used on project
 */

import PermissionValidator from './PermissionValidator.js';
export default PermissionValidator;